<template>
  <div v-if="show_historical_usage">
    ${{ format_dollar_amount(plan.total_cost) }}
  </div>
  <div v-else>
    ${{ format_dollar_amount(plan[`display_pricing_${usage_selected}`]?.total) }}
  </div>
</template>

<script>
import UsageFilters from "src/composables/UsageFilters";
import Utilities from "src/composables/Utilities";

export default {
  name: "PlanTotalPrice",
  props: {
    plan: {
      type: Object
    }
  },
  setup() {

    const { usage_selected, show_historical_usage } = UsageFilters();
    const { format_dollar_amount } = Utilities();
    return {
      show_historical_usage,
      usage_selected,
      format_dollar_amount
    }
  }
}
</script>

<style scoped>

</style>